import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MatchConnectionModal } from './MatchConnectionModal';
import { User, Entrepreneur, Investor } from '../types';

interface MatchModalProps {
  isOpen: boolean;
  currentUser: User;
  matchedUser: User;
  onClose: () => void;
  onStartChat: (conversationId: string) => void;
}

/**
 * Legacy Match Modal - Now uses MatchConnectionModal
 * This component is kept for backward compatibility
 */
export const MatchModal: React.FC<MatchModalProps> = ({
  isOpen,
  currentUser,
  matchedUser,
  onClose,
  onStartChat
}) => {
  return (
    <MatchConnectionModal
      isOpen={isOpen}
      currentUser={currentUser}
      matchedUser={matchedUser}
      matchType="normal"
      onClose={onClose}
      onConnectionSuccess={onStartChat}
    />
  );
};